import React from 'react';
import { View } from 'react-native';

import { Icon } from '../icon';
import TypographyParagraph from '../typography/TypographyParagraph';
import Text from '../text/Text';
import { useThemedStyles } from '../../hooks/useThemedStyles';

export const WarningCallout = ({ text, additionalText, rightTextIcon }) => {
	const styles = useThemedStyles(createStyles);

	return (
		<View style={styles.container}>
			<Icon
				name="exclamation"
				color={styles.iconColor.color}
				size={14}
				style={styles.icon}
			/>
			{
				!additionalText ? (
					<TypographyParagraph
						style={styles.text}
						text={text}
					/>
				) : (
					<View style={styles.additionalTextContainer}>
						<Text style={[styles.text, styles.lineHeight]}>
							{text}
						</Text>
						<View style={styles.rightTextContainer}>
							<Text style={[styles.text, styles.boldText, styles.lineHeight]}>
								{additionalText}
							</Text>
							<Icon
								name={rightTextIcon}
								color={styles.iconColor.color}
								size={14}
								style={styles.icon}
							/>
						</View>
					</View>
				)
			}
		</View>
	);
};

const createStyles = ({ ui: { colors, radius, type } }) => ({
	container: {
		flexDirection: 'row',
		alignItems: 'flex-start',
		backgroundColor: colors.warningBg,
		paddingVertical: 10,
		paddingHorizontal: 12,
		borderRadius: radius.control,
		marginBottom: 8,
		borderColor: colors.warningBorder,
		borderWidth: 1,
	},
	icon: {
		marginLeft: 2,
		marginRight: 8,
		marginTop: 3,
		alignSelf: 'flex-start',
	},
	iconColor: {
		color: colors.warning,
	},
	text: {
		...type.bodySmallStrong,
		color: colors.warning,
	},
	additionalTextContainer: {
		flexDirection: 'row',
		justifyContent: 'space-between',
		width: '98%',
	},
	rightTextContainer: {
		flexDirection: 'row',
	},
	lineHeight: {
		lineHeight: 20,
	},
	boldText: {
		...type.bodySmallSemibold,
	},
});
